/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface PaginationQueryDto
 */
export interface PaginationQueryDto {

    /**
     * When true returns only soft-deleted rows. When omitted or false, only live rows. Restore-by-id is unchanged.
     *
     * @type {boolean}
     * @memberof PaginationQueryDto
     */
    deleted?: boolean;

    /**
     * When true returns { data, meta } paginated response. When false (default) returns a plain array of all matching records ignoring page/limit.
     *
     * @type {boolean}
     * @memberof PaginationQueryDto
     */
    paginated?: boolean;

    /**
     * Page number (1-based)
     *
     * @type {number}
     * @memberof PaginationQueryDto
     * @example 1
     */
    page?: number;

    /**
     * Filter by template status. When omitted, no template filter is applied.
     *
     * @type {boolean}
     * @memberof PaginationQueryDto
     */
    isTemplate?: boolean;

    /**
     * Number of records per page
     *
     * @type {number}
     * @memberof PaginationQueryDto
     * @example 10
     */
    limit?: number;
}
